import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElSalvador = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_220)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C7.24247 0 3.13172 2.76867 1.19072 6.78263H22.8092C20.8683 2.76867 16.7575 0 12 0Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C16.7575 24 20.8683 21.2313 22.8093 17.2174H1.19072C3.13172 21.2313 7.24247 24 12 24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.59015 12.5217L12 8.34782L14.4098 12.5217H9.59015Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1305 13.8999L12 15.4651L8.86955 13.8999V11.813H15.1305V13.8999Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9514 8.52689L13.8446 9.63366C14.3167 10.1057 14.6087 10.7579 14.6087 11.4783C14.6087 12.919 13.4408 14.087 12 14.087C10.5593 14.087 9.39136 12.919 9.39136 11.4783C9.39136 10.7579 9.68339 10.1057 10.1555 9.63366L9.0487 8.52689C8.29331 9.28214 7.82616 10.3256 7.82616 11.4783C7.82616 13.7835 9.69488 15.6522 12 15.6522C14.3052 15.6522 16.1739 13.7835 16.1739 11.4783C16.1739 10.3256 15.7067 9.28214 14.9514 8.52689Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_220",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgElSalvador;
